import QuySelection from "./QuySelection";

export default QuySelection